// v2.5.0 — Écran de login livreur (token statique par société).
// Le token est stocké en sessionStorage (expire à fermeture browser).

import { useEffect, useState } from "react";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function CourierLoginScreen({ onAuthSuccess }) {
  const [companies, setCompanies] = useState([]);
  const [companyId, setCompanyId] = useState("");
  const [token, setToken] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API}/courier/companies`)
      .then((r) => r.json())
      .then((d) => {
        if (cancelled) return;
        const list = d.companies || [];
        setCompanies(list);
        if (list[0]) setCompanyId(list[0].id);
      })
      .catch(() => {
        if (!cancelled) toast.error("Impossible de charger les sociétés");
      });
    return () => { cancelled = true; };
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!token.trim()) {
      toast.error("Entre ton token de société");
      return;
    }
    setBusy(true);
    try {
      const r = await fetch(`${API}/courier/auth`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token: token.trim() }),
      });
      const d = await r.json();
      if (!r.ok || !d.ok) {
        toast.error("Token invalide. Vérifie auprès de ton entreprise.");
        return;
      }
      sessionStorage.setItem("courier_token", token.trim());
      sessionStorage.setItem("courier_company", JSON.stringify(d.company));
      toast.success(`Connecté en tant que ${d.company.logo_emoji} ${d.company.name}`);
      onAuthSuccess && onAuthSuccess(d.company, token.trim());
    } catch (_) {
      toast.error("Erreur réseau");
    } finally {
      setBusy(false);
    }
  };

  const selected = companies.find((c) => c.id === companyId);

  return (
    <div data-testid="courier-login-screen" style={{
      position: "fixed", inset: 0, display: "flex", alignItems: "center", justifyContent: "center",
      background: "linear-gradient(135deg, #0F172A 0%, #1E293B 100%)",
      padding: 20, fontFamily: "system-ui, -apple-system, sans-serif",
    }}>
      <form onSubmit={submit} style={{
        width: "100%", maxWidth: 420, background: "rgba(15,23,42,0.7)",
        border: "1px solid rgba(255,255,255,0.12)", borderRadius: 16, padding: 32,
        boxShadow: "0 24px 64px rgba(0,0,0,0.5)", backdropFilter: "blur(12px)", color: "#fff",
      }}>
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <div style={{ fontSize: 48, marginBottom: 8 }}>🛵</div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>AYA GPS Livreur</h1>
          <p style={{ marginTop: 8, fontSize: 13, color: "#94a3b8" }}>
            Connecte-toi avec ton token de société pour accéder au mode livraison.
          </p>
        </div>

        <label style={{ display: "block", marginBottom: 14 }}>
          <span style={{ display: "block", fontSize: 11, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 1, marginBottom: 6 }}>
            Société
          </span>
          <select
            data-testid="courier-login-company"
            value={companyId}
            onChange={(e) => setCompanyId(e.target.value)}
            style={{
              width: "100%", padding: "10px 12px", borderRadius: 8,
              background: "rgba(255,255,255,0.05)", color: "#fff",
              border: "1px solid rgba(255,255,255,0.15)", fontSize: 14,
            }}
          >
            {companies.map((c) => (
              <option key={c.id} value={c.id} style={{ background: "#0F172A" }}>
                {c.logo_emoji} {c.name}
              </option>
            ))}
          </select>
        </label>

        <label style={{ display: "block", marginBottom: 18 }}>
          <span style={{ display: "block", fontSize: 11, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 1, marginBottom: 6 }}>
            Token (fourni par ta société)
          </span>
          <input
            data-testid="courier-login-token"
            type="text"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            placeholder={selected ? `Ex : ${selected.id.toUpperCase()}-XXX-NNN` : "TOKEN"}
            style={{
              width: "100%", padding: "10px 12px", borderRadius: 8,
              background: "rgba(255,255,255,0.05)", color: "#fff",
              border: "1px solid rgba(255,255,255,0.15)", fontSize: 14,
              fontFamily: "monospace",
            }}
            autoComplete="off"
          />
        </label>

        <button
          data-testid="courier-login-submit"
          type="submit"
          disabled={busy}
          style={{
            width: "100%", background: "#3B82F6", color: "#fff", border: "none",
            padding: "12px 16px", borderRadius: 10, fontSize: 15, fontWeight: 600,
            cursor: busy ? "wait" : "pointer", opacity: busy ? 0.7 : 1,
          }}
        >
          {busy ? "Connexion…" : "🔐 Se connecter"}
        </button>

        <div style={{ marginTop: 16, fontSize: 11, color: "#64748b", textAlign: "center" }}>
          🇨🇮 Tu n'es pas livreur ? <a href="/" style={{ color: "#3B82F6" }}>Retour au chat</a>
        </div>
      </form>
    </div>
  );
}
